var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxdTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "#000",
    stroke: "#333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.082 34.263l7.66 8.264.877-.94-7.663-8.267 2.168-2.34 7.666 8.27.877-.94-7.669-8.272 6.933-7.479H49.69l-4.312 4.652L37.766 19l-.876.939 7.614 8.214-2.17 2.34-7.616-8.216-.876.938 7.62 8.22-4.497 4.85L24.241 22.56H19l15.345 16.554L19 55.667h5.241l12.724-13.728L49.69 55.667h5.241L39.586 39.113l4.496-4.85z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxdTokenIcon);
export default __webpack_public_path__ + "static/media/UXD-token-icon.a783b811fc9726cf3c1d345cdfd0939f.svg";
export { ForwardRef as ReactComponent };